import degreesConfig from "@2u-landing-pages/constants/configs/degrees.json";

const programConfigs = degreesConfig.programs.pep;

export const pep = {
  slug: "pep",
  name: "Pepperdine",
  colors: {
    primary1: "#fff",
    primary2: "#fecf48",
    primary3: "#d23228",
    primary4: "#1576d4",
    text: "#fff",
  },
  fonts: {
    url: "https://whitelabel.2u.com/cdn/v1/dad72cd7-61de-4bd5-899a-6ae2ae8b9387/marketing/whitelabel.fonts.min.css?ver=1.0",
    base: "PT Sans, sans-serif",
  },
  programConfigs,
};
